/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

function ResourceLoader() {
  return (
    <>
      {/* Status */}
      <circle cx="3%" cy="32" r="16" />

      {/* Platform icon */}
      <rect x="8%" y="16" rx="3" ry="3" width="32" height="32" />

      {/* Title text */}
      <rect x="15%" y="18" rx="3" ry="3" width="60%" height="14" />

      {/* ID/subtitle text */}
      <rect x="15%" y="38" rx="3" ry="3" width="45%" height="10" />

      {/* Menu dots on the right */}
      <circle cx="96%" cy="30" r="3" />
      <circle cx="96%" cy="30" r="3" transform="translate(0, -8)" />
      <circle cx="96%" cy="30" r="3" transform="translate(0, 8)" />
    </>
  );
}

export { ResourceLoader };
